import { MAX_LENGTH_NAME, isString, isValidNameLength } from "@/utils/string";

/**
 * Different type of form validators
 * @type {{default: string, mail: string, color: string, name: string}}
 */
export const FORM_VALIDATORS = {
    name: "name",
    mail: "mail",
    color: "color",
    default: "default"
};

/**
 * Test if the string is a correct color
 *
 * @param string
 * @returns {boolean}
 */
export function isColor(string) {
    let s = new Option().style;
    s.color = string; //'string' is not persisted if it's not a correct color
    return isString(string) && Boolean(s.color);
}

/***
 * Test if a value is a correct name
 * @param value
 * @returns {boolean}
 */
export function isName(string, length = MAX_LENGTH_NAME) {
    return isString(string) && isValidNameLength(string);
}

/***
 * Test if a value is a correct email
 * @param value
 * @returns {boolean}
 */
export function isMail(string) {
    const regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return isString(string) && regex.test(string);
}

/***
 * Test if a value is a correct boolean
 * @param value
 * @returns {boolean}
 */
export function isBool(bool) {
    return bool === true || bool === false;
}



// WEBPACK FOOTER //
// ./src/utils/fieldValidations.js